import addCSSRule from './addCSSRule';
import addStyleText from './addStyleText';

const resetCSS = (id, extra) => {
    // JIRA_2913 -START- Create New DOM For Desktop.
    // summary: We were just frequently calling resetCSS earlier, and even resetting 1 HTML element multiple times specially in Visitor Form scenario.
    // so, I've introduced a best practice that we are saving in Array the elements That Have Been Reset and not resetting them more than 1.
    const defaultSheetId = 'apexchat_default';
    if (ApexChat.elementsThatHaveBeenReset[id]) {
        return;
    }
    const delimitter = extra && extra.trimWhiteSpaces ? '' : '\r\n';
    ApexChat.elementsThatHaveBeenReset[id] = id;
    // JIRA_2913 -END-
    const rules = [
        `#${id}`,
        `#${id} a`,
        `#${id} *`,
        `#${id} a:hover`,
        `#${id} a:visited`,
        `#${id} a:active`
    ];
    const identity = `${rules.join(',')}{${delimitter}`;
    const props = {
        background: 'none',
        border: 'none',
        bottom: 'auto',
        clear: 'none',
        /* 'cursor':'inherit', */
        color: '#000',
        /* didn't really know what the default for display should be; of course, if someone changes the default across the board,
        they'll have some pretty funky looking results on their site... */
        /* 'display':'inline', */
        /* 'display':'block', */
        float: 'none',
        'font-family': "'Arial', 'Helvetica', sans-serif",
        'font-size': 'medium',
        'font-style': 'normal',
        'font-weight': 'normal',
        height: 'auto',
        left: 'auto',
        'letter-spacing': 'normal',
        'line-height': 'normal',
        'max-height': 'none',
        'max-width': 'none',
        margin: '0',

        overflow: 'visible',
        padding: '0',
        position: 'static',
        /* the following 3 values, if set on some elements in IE, trigger a different layout; thus, we ignore them if at all possible
        'min-height': '0',
        'min-width': '0',
        'right': 'auto', */
        'text-align': 'left',
        'text-decoration': 'none',
        'text-indent': '0',
        'text-transform': 'none',
        top: 'auto',
        visibility: 'visible',
        'white-space': 'normal',
        width: 'auto',
        'z-index': 'auto',
        'box-sizing': 'unset',
        // 'cursor': 'default',
        'min-height': 'auto',
        'min-width': 'auto',
        'font-stretch': 'normal',
        'font-variant': 'none',
        'counter-reset': 'none',
        'list-style-image': 'none',
        'list-style-type': 'none',
        outline: '0',
        'outline-color': 'transparent',
        'outline-style': 'none',
        'outline-width': 'unset',
        clip: 'unset',
        right: 'auto',
        bottom: 'auto',
        top: 'auto',
        'vertical-align': 'unset',
        'border-collapse': 'unset',
        'border-spacing': 'unset',
        'caption-side': 'unset',
        'table-layout': 'unset',
        direction: 'unset',
        'text-shadow': 'none',
        'word-spacing': 'unset',
        'white-space': 'unset',
        'list-style': 'none',
        quotes: 'none',
        transition: 'none',
        '-webkit-transition': 'none',
        '-moz-transition': 'none'
    };

    const propsList = [];
    for (const prop in props) {
        propsList.push(`${prop}:${props[prop]};`);
    }
    const result = `${identity + propsList.join(delimitter)}}`;

    // reset rules get added to the top
    addStyleText(result, defaultSheetId, true);

    // for those brilliant folks who have div { display: none; }
    let rule = addCSSRule(`#${id} div`, true);
    rule.style.display = 'block';

    // for those brilliant folks who have table { display: none; }
    rule = addCSSRule(`#${id} table`, true);
    rule.style.display = 'block';
};
export default resetCSS;
